import { styled } from '@mui/material/styles';

import TextField from '@mui/material/TextField';
  
const StyledTextField = styled(TextField)(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: theme.palette.border.primary,
        },
        '&:hover fieldset': {
            borderColor: theme.palette.border.secondary,
        },
        '&.Mui-focused fieldset': {
            borderColor: theme.palette.border.secondary,
        }
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.border.main,
        transition: theme.transitions.create(['border-color'])
    },
    '& .MuiInputAdornment-root .MuiSvgIcon-root': {
        color: theme.palette.icon.main,
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.border.active,
        borderWidth: '1px !important'
    },
    '&:active': {},
}));

export default StyledTextField;
